import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import InputText from "../../../components/input/InputText";
import { toast } from "react-toastify";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";

const RenameCollection = (props) => {
  const isMobile = useIsMobile();

  const [name, setName] = useState();
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const { renamePopup, setRenamePopup, renameCollection, setDarkBackground } =
    props;

  const handleRename = () => {
    if (name.length === 0) {
      toast.error("Title cannot be empty. Please enter a valid title.");
    } else {
      renameCollection(name);
      setName("");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleRename();
    }
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  const closePopup = () => {
    setRenamePopup(false);
    setDarkBackground(false);
  };

  return (
    renamePopup && (
      <>
        <Draggable
          defaultPosition={{ x: position.marginLeft, y: position.marginTop }}
          onDrag={handleDrag}
          cancel={isMobile ? ".new-share-popup" : null}
        >
          <div onKeyDown={(e) => handleKeyDown(e)} className="new-share-popup">
            <div className="popup-card rename-card">
              <CloseIcon className="cross" onClick={closePopup} />

              <p className="popup-title">
                Please enter the new title for this collection.{" "}
              </p>
              <InputText
                placeholder="Enter Collection name"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
              <div className="save-actions">
                <div />
                <div className="flex">
                  <ButtonPrimary
                    text="Cancel"
                    onClick={closePopup}
                    className="mr-2 grey"
                    outline
                  />
                  <ButtonPrimary text="Rename" onClick={handleRename} />
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      </>
    )
  );
};

export default RenameCollection;
